export const PRODUCT_URL = '/api/proxy/product/{{sku}}';
export const STOCK_STATUS_URL = '/api/proxy/product/{{sku}}/stock';
export const STOCK_STATUS_NO_TRACK_URL = '/api/proxy/product/{{sku}}/stockNoTrack';
